import React from 'react';

import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { NamedLink } from '../../components';

import css from './ListingPage.module.css';

/**
 * Visible trail from the home page to the listing's category landing page.
 *
 * @component
 * @param {Object} props
 * @param {{ slug: string, label: string }} props.category - The listing's category
 * @returns {JSX.Element} breadcrumb navigation
 */
const ListingBreadcrumbs = props => {
  const { category } = props;
  const intl = useIntl();

  return (
    <nav
      className={css.breadcrumbs}
      aria-label={intl.formatMessage({ id: 'ListingPage.breadcrumbsLabel' })}
    >
      <ol className={css.breadcrumbList}>
        <li>
          <NamedLink className={css.breadcrumbLink} name="LandingPage">
            <FormattedMessage id="ListingPage.breadcrumbHome" />
          </NamedLink>
        </li>
        <li>
          <NamedLink className={css.breadcrumbLink} name="CategoryHubPage">
            <FormattedMessage id="ListingPage.breadcrumbCategories" />
          </NamedLink>
        </li>
        <li>
          <NamedLink
            className={css.breadcrumbLink}
            name="CategoryLandingPage"
            params={{ slug: category.slug }}
          >
            {category.label}
          </NamedLink>
        </li>
      </ol>
    </nav>
  );
};

export default ListingBreadcrumbs;
